import { varchar } from "drizzle-orm/pg-core"

// EVery id in the system consists of a three digit prefix, a hyphen, and then a ulid code
export const id_length = 4 + 26

export const ulidId = () => {
  return varchar("id", { length: id_length }).primaryKey()
}

export const email_length = 255
